export const useHostName = (): string => {
  if (typeof window === 'undefined') return ''; // ssr fallback

  return window.location.hostname === 'localhost'
    ? 'xing' // fallback just for local environments
    : window.location.hostname;
};
